import { useState, useEffect } from 'react';

function useLocalStorageList(localStorageKey, itemId) {
  const [isInList, setIsInList] = useState(false);

  useEffect(() => {
    const storedItems = JSON.parse(localStorage.getItem(localStorageKey)) || [];
    setIsInList(storedItems.includes(itemId));
  }, [localStorageKey, itemId]);

  const addItem = () => {
    const storedItems = JSON.parse(localStorage.getItem(localStorageKey)) || [];
    if (!storedItems.includes(itemId)) {
      storedItems.push(itemId);
      localStorage.setItem(localStorageKey, JSON.stringify(storedItems));
      setIsInList(true);
    }
  };

  const removeItem = () => {
    let storedItems = JSON.parse(localStorage.getItem(localStorageKey)) || [];
    storedItems = storedItems.filter(id => id !== itemId);
    localStorage.setItem(localStorageKey, JSON.stringify(storedItems));
    setIsInList(false);
  };

  return { isInList, addItem, removeItem };
}
export default useLocalStorageList;